export default {
      id: "zoom_plus-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#zoom_plus",
      toString: function () {
        return this.url;
      }
    }